export default {
    SELECT({ commit }, payload) {
        commit('SELECT', payload)
    },
    LAUNCH_RESEARCH({commit}, payload) {
        commit('LAUNCH_RESEARCH', payload)
    },
};